import {Component, OnDestroy, OnInit, AfterViewInit, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../store';
import {Website} from "../../website";
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {HostingService} from "../hosting.service";
import {Subscription} from 'rxjs';
import {IDropdownListItem} from "../../../../shared/components/dropdown-list/dropdown-list-item";
import {FormControl, FormGroup} from '@angular/forms';
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {DbServerErrors} from "../../../../shared/interceptors/db-server-errors";
import {RemoveDnsDialogComponent} from "./remove-dns-dialog/remove-dns-dialog.component";
import {ConfirmDialogComponent} from "../../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {TextUtils} from "../../../../shared/utils/text-utils";
import {TxtContentDnsDialogComponent} from "./txt-content-dns-dialog/txt-content-dns-dialog.component";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {AddDnsDialogComponent} from "./add-dns-dialog/add-dns-dialog.component";
import {filter, first, switchMap} from 'rxjs/operators';
import {
  IFcDropdownSelectOption
} from "../../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";

@Component({
    selector: 'db-hosting-domains-manage-dns',
    templateUrl: './hosting-domains-manage-dns.component.html',
    styleUrls: ['./hosting-domains-manage-dns.component.scss'],
    standalone: false
})
export class HostingDomainsManageDNSComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() zone: any;
  @Input() insideTab: boolean = false;
  public domainId: any;
  public website: Website;
  public addRecordForm: FormGroup;
  public subscriptions: Subscription[];
  public RemoveRecord: IDropdownListItem[];
  public formValid: boolean;
  public loading: boolean;
  public removeLoading: boolean;
  public isExternal: boolean;
  public websiteCopied: boolean = false;
  public serverErrors: DbServerErrors;
  public hasServerFieldErrors: boolean;
  public txtContent: any = FormControl;


  public isScrolled: boolean;
  public position: number = 50;
  public scrolled: number = 50;
  public domainOptions: Array<IFcDropdownSelectOption> = [
    {
      "value": "new",
      "label": TextUtils.getText("text_addNew"),
    },
    {
      "value": "zoho",
      "label": TextUtils.getText("text_addZohoRecord")
    },
    {
      "value": "gmail",
      "label": TextUtils.getText("text_addGmailRecord")
    }
  ];


  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _hostingService: HostingService,
    private _router: Router,
    // private _malihuScrollbarService: MalihuScrollbarService,
    private _route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.RemoveRecord = [
      {
        icon: 'plugins',
        label: 'Remove Record',
        action: (item) => {
          this.confirmRemove(item);
        }
      }
    ];
    this.isExternal = <any>this._route.snapshot.data['external'];
    if (!this.isExternal) {
      this.website = this._route.snapshot.parent.parent.data['website'];
    }
    this.zone = this.zone || this._route.snapshot.parent.data['hostingZoneData'];
    const zoneId: any = this._route.snapshot.params['zId'] || this.zone.zone['id'];
    this.addEventHandlers(zoneId);
    if (!this.zone) {
      this._store.dispatch(new fromStore.LoadZone({zoneId: zoneId}));
    }
  }

  ngAfterViewInit(): void {
    /*    document.getElementById("db-dns-block-body") && window.innerWidth > 991 && this._malihuScrollbarService.initScrollbar(document.getElementById("db-dns-block-body"), Object.assign(Config.malihuScrollbarDefaultOptions, {
          callbacks: {
            onScroll: () => {
              const offsetTop = <HTMLElement> document.querySelector('.db-dns-block-body .mCSB_container');
              if (offsetTop) {
                this.scrolled = 1 - offsetTop.offsetTop;
                /!*if (this.scrolled >= this.position) {*!/
                this.isScrolled = this.scrolled > 10;
                setTimeout(() => {
                  this.position = this.scrolled;
                }, 1000);
              }
            }
          }
        }));*/
  }

  private addEventHandlers(zoneId): void {
    this.subscriptions = [];
    this.subscriptions.push(this._store.select(fromStore.getZone(zoneId)).subscribe((zone: any) => {
      if (zone && !TypeUtils.isEmpty(zone)) {
        this.zone = zone;
      }
    }));

    this.subscriptions.push(this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((websitesLoaded: boolean) => websitesLoaded),
        switchMap(() => this._store.select(fromStore.getHostedWebsites)),
        filter((hostedWebsites: Website[]): boolean => !!hostedWebsites.length)
      )
      .subscribe((hostedWebsites: Website[]) => {
        this.websiteCopied = true;
      })
    );

  }

  public confirmRemove(zoneRecord) {
    this._dialogService
      .addDialog(RemoveDnsDialogComponent, {
        zoneId: this.zone.zone.id,
        recordId: zoneRecord.id,
        website: this.website
      }).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this._store.dispatch(new fromStore.LoadZone({zoneId: this.zone.zone.id}));
      }
    });
  }

  public addRecord(record?: any | null, recordType?: string | null) {
    this._dialogService
      .addDialog(AddDnsDialogComponent, {
        zohoMxRecord: recordType === 'zoho',
        gmailMxRecord: recordType === 'gmail',
        record: record,
        zone: this.zone.zone,
        website: this.website
      }).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this._store.dispatch(new fromStore.LoadZone({zoneId: this.zone.zone.id}));
      }
    });
  }


  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this.subscriptions = null;
  }

  public showTxtContent(fromType: string) {
    this._dialogService.addDialog(TxtContentDnsDialogComponent, {
      txtContent: this.txtContent,
      fromType: fromType
    }).subscribe((reopenLast: any): void => {
      if (reopenLast) {
        this.txtContent = reopenLast;
      }
    });
  }


  private removeDomain() {
    this.removeLoading = true;
    this._hostingService.removeZone(this.zone.zone.id)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadZones());
          this._router.navigate(["/domains-manage-all"]);
        }
        this.removeLoading = false;
      });
  }

  public confirmRemoveDomain() {
    this._dialogService
      .addDialog(ConfirmDialogComponent, {
        header: TextUtils.getText('text_confirmDomainNameRemove.header'),
        message: TextUtils.getText('text_removeZoneWarn', {
          domainName: this.zone.zone.name
        }),
        cancelButtonText: TextUtils.getText('text_cancel'),
        confirmButtonText: TextUtils.getText('text_yesRemove'),
        checkSubdomain: true,
        alignLeft: true,
        width: '700px'
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.removeDomain();
        }
      });
  }

}
